





















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ToggleTitle from '@/components/default/ToggleTitle.vue';

@Component({
  components: {
    ToggleTitle,
  },
})
export default class Card extends Vue {
  @Prop({ required: true })
  public title?: string;

  @Prop({ required: false })
  public backUrl?: string;

  @Prop({ required: false })
  public icon?: string;

  @Prop({ required: false, default: true })
  public standalone?: boolean;

  @Prop({ required: false, default: false })
  public expanded?: boolean;

  @Prop({ required: false, default: false })
  public hasSidenav!: boolean;

  @Prop({ required: false, default: false })
  public showBack?: boolean;

  @Prop({ required: false, default: false })
  public showAddButton?: boolean;

  @Prop({ required: false, default: false })
  public disableAddButton?: boolean;

  @Prop({ required: false, default: false })
  public showEditButton?: boolean;

  @Prop({ required: false, default: false })
  public disableEditButton?: boolean;

  @Prop({ required: false, default: false })
  public showRemoveButton?: boolean;

  @Prop({ required: false, default: false })
  public showSaveButton?: boolean;

  @Prop({ required: false, default: false })
  public disableRemoveButton?: boolean;

  @Prop({ required: false, default: false })
  public showRefreshButton?: boolean;

  @Prop({ required: false, default: false })
  public loading?: boolean;

  @Prop({ required: false, default: false })
  public saving?: boolean;

  @Prop({ required: false, default: false })
  public refreshing?: boolean;

  @Prop({ required: false, default: false })
  public showFooter?: boolean;

  @Prop({ required: false, default: '' })
  public background?: string;

  public showContent: boolean = false;

  public clicked() {
    // this.$emit("input", !this.value);
  }

  public add() {
    this.$emit('add');
  }

  public refresh() {
    this.$emit('refresh');
  }

  public remove() {
    this.$emit('remove');
  }

  public edit() {
    this.$emit('edit');
  }

  public setShowContent(value: boolean) {
    this.showContent = value;
  }

  public save() {
    this.$emit('save');
  }

  get bg() {
    // {'bg-primary': standalone, 'bg-success': !standalone}
    if (this.background && this.background !== '') {
      return this.background;
    }

    if (!this.standalone) {
      return 'bg-success';
    }

    return 'bg-primary';
  }
}
